<template>
  <div>
    <el-form label-position="top" class="u-mb-10" v-if="exibeSelectInstituicao">
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24" :md="24">
          <el-form-item label="Instituição">
            <el-select v-model="filtroInstituicao.id" filterable disabled placeholder="Instituição" style="width:100%">
              <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
            </el-select>
            <small class="u-text-muted">Para trocar de instituição, volte para a listagem.</small>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div v-if="editGasto && !dados.id" class="loading-form" style="min-height: 130px;">
      <img src="/public/img/loading-bar.gif" />
    </div>

    <el-form @submit.native.prevent="onSubmitGasto" v-if="!editGasto || dados.id" :model="dados" ref="dados" label-position="top">
      <div v-if="!editGasto || dados.id">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item label="Recurso" prop="recurso_id" :rules="[$requiredChange]" key="recurso_id">
              <el-select v-model="dados.recurso_id" placeholder="pesquisar..." filterable remote :remote-method="getRecursoByFilter" :loading="loadingRecurso">
                <el-option v-for="item in recursos" :key="item.id" :label="recursoLabel(item)" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item label="Fornecedor" prop="fornecedor_id" key="fornecedor_id">
              <el-select v-model="dados.fornecedor_id" placeholder="pesquisar..." filterable remote clearable :remote-method="getFornecedorByFilter" :loading="loadingFornecedor">
                <el-option v-for="item in fornecedores" :key="item.id" :label="item.nome" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Tipo do gasto" prop="tipo_recurso" :rules="[$requiredChange]" key="tipo_recurso">
              <el-select v-model="dados.tipo_recurso">
                <el-option label="CAPITAL" value="capital"></el-option>
                <el-option label="CUSTEIO" value="custeio"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Valor total" prop="valor_total" :rules="[$requiredBlur]" key="valor_total">
              <el-input v-model="dados.valor_total" maxlength="20"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Data da compra" prop="data_compra" key="data_compra">
              <el-date-picker v-model="dados.data_compra" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" placeholder="Selecione"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Cotação (opcional)" prop="cotacao_id" key="cotacao_id">
              <el-select v-model="dados.cotacao_id" placeholder="pesquisar..." filterable remote clearable :remote-method="getCotacaoByFilter" :loading="loadingCotacao">
                <el-option v-for="item in cotacoes" :key="item.id" :label="cotacaoLabel(item)" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Nota fiscal (referência)" prop="nota_fiscal" key="nota_fiscal">
              <el-input v-model="dados.nota_fiscal" maxlength="191"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Documento (referência)" prop="documento" key="documento">
              <el-input v-model="dados.documento" maxlength="191"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24">
            <el-form-item class="u-text-right u-mt-15">
              <el-button type="primary" id="btn-gasto" native-type="submit">SALVAR</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  props: ['paramId'],
  data: () => ({
    editGasto: false,
    loadingRecurso: false,
    recursos: [],
    loadingFornecedor: false,
    fornecedores: [],
    loadingCotacao: false,
    cotacoes: [],
    filtroInstituicao: { id: '', nome: '' },
    dados: {
      id: '',
      instituicao_id: '',
      recurso_id: '',
      cotacao_id: '',
      fornecedor_id: '',
      valor_total: '',
      data_compra: '',
      nota_fiscal: '',
      documento: '',
      tipo_recurso: 'custeio'
    }
  }),
  computed: {
    exibeSelectInstituicao () {
      const t = Number(this.$store.state.user.tipo)
      return (t > 3 && t <= 8) || t === 10
    }
  },
  mounted () {
    this.restaurarInstituicaoDoQuery()
    if (this.$store.state.config.instituicao) {
      this.filtroInstituicao = { id: this.$store.state.config.instituicao.id, nome: this.$store.state.config.instituicao.nome }
    }
  },
  methods: {
    restaurarInstituicaoDoQuery () {
      const qId = this.$route.query.instituicao_id
      if (!qId) return
      const atual = this.$store.state.config.instituicao
      if (atual && atual.id && String(atual.id) === String(qId)) return
      const lista = this.$store.state.instituicoes || []
      const fromList = Array.isArray(lista)
        ? lista.find(x => x && String(x.id) === String(qId))
        : (lista[qId] || null)
      const inst = fromList || { id: qId, nome: '' }
      this.$store.commit('setInstituicao', inst)
    },
    getGastoById (id) {
      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/financeiro/gasto/getById/` + id, this.$store.getters.getHeaderAuth)
        .then(response => {
          const data = JSON.parse(JSON.stringify(response.data))

          // Pré-popular options dos selects remotos (senão eles mostram o ID)
          if (data && data.recurso) {
            this.recursos = [data.recurso]
            delete data.recurso
          }
          if (data && data.fornecedor) {
            this.fornecedores = [{ id: data.fornecedor.id, nome: data.fornecedor.nome }]
            delete data.fornecedor
          }
          if (data && data.cotacao) {
            this.cotacoes = [data.cotacao]
            delete data.cotacao
          }

          this.dados = data
        })
        .catch((error) => { this.$store.commit('throwException', error) })
    },
    getRecursoByFilter (query) {
      if (!query || query.length < 2) {
        this.recursos = []
        return false
      }
      this.loadingRecurso = true
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/financeiro/recurso/searchByNome`, { query }, this.$store.getters.getHeaderAuth).then(response => {
        this.recursos = JSON.parse(JSON.stringify(response.data))
        this.loadingRecurso = false
      }).catch((error) => { this.loadingRecurso = false; this.$store.commit('throwException', error) })
    },
    getFornecedorByFilter (query) {
      if (!query || query.length < 2) {
        this.fornecedores = []
        return false
      }
      this.loadingFornecedor = true
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/financeiro/fornecedor/searchByNome`, { query }, this.$store.getters.getHeaderAuth).then(response => {
        this.fornecedores = JSON.parse(JSON.stringify(response.data))
        this.loadingFornecedor = false
      }).catch((error) => { this.loadingFornecedor = false; this.$store.commit('throwException', error) })
    },
    getCotacaoByFilter (query) {
      if (!query || query.length < 2) {
        this.cotacoes = []
        return false
      }
      this.loadingCotacao = true
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/financeiro/cotacao/searchByNome`, { query }, this.$store.getters.getHeaderAuth).then(response => {
        this.cotacoes = JSON.parse(JSON.stringify(response.data))
        this.loadingCotacao = false
      }).catch((error) => { this.loadingCotacao = false; this.$store.commit('throwException', error) })
    },
    recursoLabel (item) {
      const programa = item.programa ? item.programa.nome : ('#' + item.programa_id)
      return `${programa} - ${item.ano} - ${this.formatMoney(item.valor_total)}`
    },
    cotacaoLabel (item) {
      const num = item.numero_processo || ('#' + item.id)
      const status = item.status ? item.status.toUpperCase() : ''
      return `${num} - ${status}`
    },
    onSubmitGasto () {
      document.getElementById("btn-gasto").focus()
      this.$refs.dados.validate((valid) => {
        if (valid) {
          const inst = this.$store.state.config.instituicao
          if (!inst || !inst.id) {
            return window.eventBus.$emit('alert', { msg: 'Selecione uma instituição antes de salvar.', type: 'warning' })
          }
          window.eventBus.$emit('loading', true)
          this.dados.instituicao_id = inst.id
          if (this.editGasto) {
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/financeiro/gasto/update/` + this.dados.id, this.dados, this.$store.getters.getHeaderAuth).then(() => {
              window.eventBus.$emit('loading', false)
              window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
              this.$emit('onSubmitGasto')
            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
          } else {
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/financeiro/gasto/store`, this.dados, this.$store.getters.getHeaderAuth).then(() => {
              window.eventBus.$emit('loading', false)
              window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
              this.$emit('onSubmitGasto')
            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
          }
        } else {
          window.eventBus.$emit('alert', { msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning' })
        }
      })
    },
    formatMoney (value) {
      const v = Number(value || 0)
      return v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    }
  },
  watch: {
    paramId: {
      immediate: true,
      handler (value) {
        if (value) {
          this.getGastoById(value)
          this.editGasto = true
        }
      }
    }
  }
}
</script>

